import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { ConfigService } from '../../../../core';
import { ConfigAnaliseMercado } from '../../../configuracoes/app/analise-mercado';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { ClienteAnaliseMercadoStatusPretendido, statusPretendidos, statusPretendidoNaoPretendido, statusPretendidoPretendido, statusPretendidoPotencial, statusPretendidoRealizado, isStatusPretendidoPotencial } from '../cliente-analise-mercado-status-pretendido';
import { ClienteAnaliseMercadoStatusPretendidoPipe } from '../pipes';

@Component({
    selector: 'sgt-cliente-analise-mercado-status-pretendido-multiselect',
    templateUrl: './cliente-analise-mercado-status-pretendido-multiselect.component.html',
    styleUrls: ['./cliente-analise-mercado-status-pretendido-multiselect.component.less']
})
export class ClienteAnaliseMercadoStatusPretendidoMultiselectComponent implements OnInit {
    configAnaliseMercado: ConfigAnaliseMercado;

    /** Status pretendidos selecionados */
    @Input() statusPretendidos: number[];
    /** Ao alterar a seleção dos status */
    @Output() statusPretendidosChange = new EventEmitter<number[]>();

    @Input() disabled = false;

    // Settings
    settings: IMultiSelectSettings = {
        pullRight: true,
        enableSearch: true,
        containerClasses: 'container-multiselect container-multiselect-cliente-analise-mercado-status-pretendido',
        showCheckAll: true,
        showUncheckAll: true,
        dynamicTitleMaxItems: 0,
    }
    // Texts
    texts: IMultiSelectTexts = {
        checkAll: 'Selecionar todos',
        uncheckAll: 'Limpar',
        checked: 'status',
        checkedPlural: 'status',
        searchPlaceholder: 'Pesquisar...',
        defaultTitle: 'Status',
        allSelected: 'Todos selecionados',
        searchEmptyResult: 'Nenhum status encontrado',
        searchNoRenderText: 'Digite para pesquisar'
    }
    // Options
    options: IMultiSelectOption[];

    constructor(private configService: ConfigService,
                private clienteAnaliseMercadoStatusPretendidoPipe: ClienteAnaliseMercadoStatusPretendidoPipe) { }

    ngOnInit() {
        this.configAnaliseMercado = this.configService.getAnaliseMercado();
        this.create();
    }

    /** Cria os status pretendidos para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];
        for (let i = 0; i < statusPretendidos.length; i++) {
            const status = statusPretendidos[i];
            // Potencial sem ser solicitado o potencial
            if (isStatusPretendidoPotencial(status.id) && !this.configAnaliseMercado?.solicitarPotencial) {
                continue;
            }

            selects.push({
                id: status.id,
                name: this.clienteAnaliseMercadoStatusPretendidoPipe.transform(status.id),
                classes: this.getMultiselectItemClasses(status)
            });
        }

        this.options = selects;
    }

    /** Obtem as classes CSS para o item do multiselect do status */
    private getMultiselectItemClasses(status: ClienteAnaliseMercadoStatusPretendido): string {
        switch (status) {
            case statusPretendidoNaoPretendido:
                return 'multiselect-item-cliente-analise-mercado-status-pretendido multiselect-item-cliente-analise-mercado-status-pretendido-nao-pretendido';
            case statusPretendidoPretendido:
                return 'multiselect-item-cliente-analise-mercado-status-pretendido multiselect-item-cliente-analise-mercado-status-pretendido-pretendido teste';
            case statusPretendidoPotencial:
                return 'multiselect-item-cliente-analise-mercado-status-pretendido multiselect-item-cliente-analise-mercado-status-pretendido-potencial teste';
            case statusPretendidoRealizado:
                return 'multiselect-item-cliente-analise-mercado-status-pretendido multiselect-item-cliente-analise-mercado-status-pretendido-realizado';
            default:
                break;
        }
    }

    /** Ao alterar a seleção dos status */
    onChange() {
        this.statusPretendidosChange.emit(this.statusPretendidos);
    }
}
